import { createRouter, createWebHistory } from "vue-router";

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", component: () => import("./views/HomeView.vue") },
    { path: "/j/:slug", name: "join", component: () => import("./views/JoinView.vue"), props: true },
    { path: "/g/:slug", name: "game", component: () => import("./views/GameView.vue"), props: true },
    { path: "/f/:slug", name: "final", component: () => import("./views/FinalView.vue"), props: true },
    { path: "/admin", name: "admin", component: () => import("./views/admin/AdminHome.vue") },
    { path: "/admin/new", name: "admin-new", component: () => import("./views/admin/AdminNew.vue") },
    { path: "/admin/g/:id", name: "admin-game", component: () => import("./views/admin/AdminGame.vue"), props: true },
    { path: "/:rest(.*)*", component: () => import("./views/HomeView.vue") },
  ],
});
